import axios from "axios";

import baseDomain, { tagAPI } from "../../Constants/apiRoutes";

export const createTag = (data) => {
  return axios.post(`${baseDomain}${tagAPI}`, data);
};
